import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-range',
	templateUrl:'./WaRangePage.html',
	styles: [],
	styleUrls:['./WaRangePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaRangePage
{
	mdContent_435 = `\`\`\`java
import com.jwebmp.webawesome.components.range.WaRange;
\`\`\``;
	mdContent_436 = `\`\`\`java
var range = new WaRange<>();
range.setLabel("Volume");
range.setMin(0);
range.setMax(100);
range.setValue(50);
range.setTooltip(RangeTooltipPosition.Top);
\`\`\``;
}
